import { Container, Filters } from '../../../../components'
import { CreditsUsageCards } from './components/CreditsUsageCards'
import { CreditsUsageChart } from './components/CreditsUsageChart'
import { DateSelect } from '../../../../components/DateSelect'
import { FilterDrawer } from '../../../../components/FilterDrawer'
import { FilterDrawerButton } from '../../../../components/FilterDrawerButton'
import { FilterDrawerStack } from '../../../../components/FilterDrawerStack'
import { PeriodType, UUID } from '@indigohive/cogfy-types'
import { ProvidersUsagesChart } from '../ConnectionsUsagesPage/components/ProvidersUsagesChart'
import { useFilters, useTitle, useWorkspace } from '../../../../hooks'
import { useParams } from 'react-router-dom'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export function CreditsUsagePage () {
  const params = useParams<{ workspace: string }>()
  const getWorkspace = useWorkspace(params.workspace!)
  const { t } = useTranslation()

  useTitle({
    title: t('Credits usage'),
    loading: getWorkspace.isLoading,
    error: getWorkspace.isError
  })

  const [startDate, setStartDate] = useState<Date | undefined>(undefined)
  const [endDate, setEndDate] = useState<Date | undefined>(undefined)
  const [open, setOpen] = useState(false)
  const [periodType, setPeriodType] = useState<PeriodType>('today')
  const filtersHook = useFilters([
    { name: t('Collection'), valueLabel: t('All'), value: undefined }
  ])

  const collection = filtersHook.filters.find(f => f.name === t('Collection'))

  return (
    <Container className="flex flex-col gap-6 !px-0">
      <div className='flex flex-row justify-end items-end gap-4 sticky top-0 z-10 border-b-2 bg-white py-3 px-2 mt-4'>
        <Filters filtersHook={filtersHook} />
        <FilterDrawerButton onClick={() => setOpen(true)} />
        <DateSelect
          className='!w-fit'
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          periodType={periodType}
          setPeriodType={setPeriodType}
          setOpen={setOpen}
        />
      </div>
      <FilterDrawer open={open} setOpen={setOpen} >
        <FilterDrawerStack
          filtersHook={filtersHook}
          renderCollection
        />
      </FilterDrawer>
      <CreditsUsageCards
        startDate={startDate}
        endDate={endDate}
        collectionId={collection?.value as UUID | undefined}
      />
      <CreditsUsageChart
        startDate={startDate}
        endDate={endDate}
        collectionId={collection?.value as UUID | undefined}
      />
      <ProvidersUsagesChart
        connectionOwner={['cogfy']}
        startDate={startDate}
        endDate={endDate}
      />
    </Container>
  )
}
